module.exports = __webpack_public_path__ + "static/btclassic-windows-screen-0a031b6392581068d5397bc2e2409a2f.jpg";